import React from 'react';
import { FaUpload } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import UploadAttachments from "views/pages/manage/edpOps/stockManagement/stockConsumption/form/UploadAttachments";
import { openFileInNewWindow } from '../../../../academicPlanAndTest/academicTimetable/lectureModule/LectureListItem';
import { detailsRowStyles } from '../../../constant/student-details';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';


const AdmissionForm = ({
    admissionFormSaveHandler,
    activeApplicationDetails
}) => {

    const { updatedOn, marksheetAndAdmissionKey } = activeApplicationDetails ?? {};

    return (
        <div style={detailsRowStyles}>
            <div className='d-flex justify-content-between'>
                <div>Admission Form</div>

                <div>
                    {marksheetAndAdmissionKey
                        ?
                        <span style={{ cursor: "pointer" }}>
                            <FaRegEye
                                onClick={() => openFileInNewWindow(marksheetAndAdmissionKey)}
                                size={18}
                                color="00b0f5"
                            />
                        </span>

                        :
                        <span style={{ cursor: "pointer" }}>
                            <UploadAttachments
                                uploadFileHeader="Upload Admission Form"
                                maxAllowedFileSize={5}
                                supportedFileTypes={["pdf"]}
                                serviceName="MARKSHEET_ADMISSION_FORM_PDF"
                                customUploadButton={(onClick) => (
                                    <FaUpload
                                        color="#00b0f5"
                                        onClick={onClick}
                                        size={18}
                                    />
                                )}
                                saveCallback={(e) =>
                                    admissionFormSaveHandler(
                                        e,
                                        activeApplicationDetails["applicationId"]
                                    )
                                }
                            />
                        </span>
                    }
                </div>


            </div>

            {marksheetAndAdmissionKey && <div className='uploaded-on-info'>Uploaded on : {getFormatedDate(updatedOn, true, 'DD/MM/YYYY')}</div>}
        </div>
    );
}

export default AdmissionForm;